
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import OwnerSignupForm from '../components/OwnerSignupForm';
import '../shop_registration_styles.css';

function ShopRegistrationPage() {
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleOwnerSignup = async (formData) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/owners/register`,
        formData
      );
      setSubmitted(true);
    } catch (error) {
      alert(error.response?.data?.message || 'Registration failed. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="shop-registration-page">
        <div style={{ padding: '40px', textAlign: 'center', maxWidth: '500px', margin: '0 auto' }}>
          <h2 style={{ color: '#001d4a', marginBottom: '20px' }}>Check Your Email</h2>
          <p style={{ marginBottom: '15px' }}>
            We've sent a verification link to your email address. 
          </p>
          <p style={{ marginBottom: '15px' }}>
            Please click the link in the email to verify your account, then return to login.
          </p>
          <button 
            onClick={() => navigate('/login')} 
            style={{ 
              marginTop: '20px', 
              padding: '12px 24px', 
              background: '#001d4a', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="shop-registration-page">
      <div className="progress-indicator">
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#003087', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '32px', fontWeight: 'bold' }}>
            OS
          </div>
        </div>
      </div>
      <OwnerSignupForm onNext={handleOwnerSignup} />
    </div>
  );
}

export default ShopRegistrationPage;
